<template>
    <div class="w-full">

        <loading v-show="loading"></loading>

        <div v-if="!loading">
            <ul class="breadcrumb list-reset flex text-grey flex-wrap pb-2">
                <li v-for="item in folder.path">
                    <a @click="$emit('folder', item.db, item.name)" class="cursor-pointer p-2">
                        <i class="fa fa-folder"></i> {{ item.translations.en }}
                    </a>
                </li>
            </ul>

            <div class="bg-white mt-4 mb-8 shadow rounded w-full">
                <h2 class="pl-8 py-4 text-xl">{{ folder.folder.translations.en }}</h2>
                <ul class="list-reset">
                    <li v-for="folder in folder.folders" class="border-t">
                        <a @click="$emit('folder', folder.db, folder.name)"
                           class="cursor-pointer px-2 lg:px-8 hover:bg-blue-lighter py-4 text-black no-underline block flex">
                            <div class="text-lg">
                                <i class="fa fa-fw fa-caret-right text-grey"></i>
                                <i class="fa fa-fw fa-folder text-blue-dark"></i>
                                {{ folder.translations.en }}
                            </div>
                        </a>
                    </li>
                    <li v-for="item in folder.indicators" class="border-t">
                        <library-menu-indicator :item="item" @database="$emit('database', item.name)"></library-menu-indicator>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import LibraryMenuIndicator from "./Library/LibraryMenuIndicator";
    export default {
        name: "LibraryFolder",
        components: {LibraryMenuIndicator},
        props: ['sourceId'],

        watch: {
            sourceId() {
                this.load();
            }
        },

        created() {
            this.load();
        },

        data: () => ({
            folder: {
                path: [],
                indicators: [],
                folders: [],
                folder: {},
            },
            loading: true,
        }),

        methods: {
            load() {
                let that = this;
                that.loading = true;
                http.get('/api/v1/sources/' + this.sourceId.source + '/' + this.sourceId.id).then((response) => {
                    that.folder.folder = response.data.folder;
                    that.folder.path = response.data.path;
                    that.folder.indicators = response.data.indicators;
                    that.folder.folders = response.data.folders;
                    that.loading = false;
                });
            }
        }
    }
</script>
